<template>
  <v-hover v-slot="{ hover }">
    <v-col cols="auto" class="hovercol d-flex align-center justify-center px-3" :class="[
      !roundTop || 'rounded-top-subtle',
      !roundBottom || 'rounded-bottom-subtle'
    ]" @click.stop="loading ? undefined : handleDelete()">
      <v-icon v-if="!loading" :size="size" v-text="hover ? 'mdi-delete-empty' : 'mdi-delete'"
        :color="hover ? 'error' : ''">
      </v-icon>
      <v-progress-circular v-else indeterminate :size="size" width="2" color="primary">
      </v-progress-circular>
    </v-col>
  </v-hover>
</template>


<script>
export default {
  name: "SpecialDeleteButton",
  props: {
    deleteFunc: {
      type: Function,
      required: true,
    },
    roundTop: Boolean,
    roundBottom: Boolean,
    size: {
      type: Number,
      default: 20
    }
  },
  components: {},

  data() {
    return {
      loading: false,
    };
  },

  methods: {
    async handleDelete() {
      if (this.loading) return;
      this.loading = true;
      try {
        // Let the UI render the loading state before executing the delete work
        await this.$nextTick();
        await new Promise(resolve => requestAnimationFrame(() => resolve()));
        await Promise.resolve(this.deleteFunc());
      } finally {
        this.loading = false;
      }
    },
  },

  computed: {},

  watch: {},
};
</script>


<style>
.rounded-bottom-subtle {
  border-bottom-left-radius: 6px;
  border-bottom-right-radius: 6px;
}

.rounded-top-subtle {
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
}
</style>